import { useEffect, useState } from "react";

const useCountUpTrigger = (endValue, isCountUpReady) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (isCountUpReady) {
      let start = 0;
      const duration = 500; // Duration of the animation in ms (you may adjust for smoother/slower effect)
      const stepTime = 20; // Smaller step time gives smoother animation
      const increment = endValue / (duration / stepTime);

      const counter = setInterval(() => {
        start += increment;
        if (start >= endValue) {
          start = endValue; // To avoid rounding issues
          clearInterval(counter);
        }
        setCount(Math.round(start));
      }, stepTime);

      // Cleanup to clear the interval if the component unmounts
      return () => clearInterval(counter);
    } else {
      // If not ready, reset count
      setCount(0);
    }
  }, [endValue, isCountUpReady]);

  return count;
};

export default useCountUpTrigger;
